// 获取今天的时间
export const getTodayTime =()=>{
    let currentime = new Date()
    let year = currentime.getFullYear()
    let month = currentime.getMonth() + 1
    let day = currentime.getDate()
    return correction(year) + '-' + correction(month) + '-' + correction(day)
}

// 获取今天和昨天的时间
export const getTodayYesTime =()=>{
    let currentime = new Date()
    let year = currentime.getFullYear()
    let month = currentime.getMonth() + 1
    let day = currentime.getDate()
    // console.log(year,month,day);
    let time = {
        today : correction(year) + '-' + correction(month) + '-' + correction(day),
        yesterday : correction(year) + '-' + correction(month) + '-' + correction(day - 1)
    }
    return time
}

// 一位数前补0
const correction = (time)=>{
    return time>=0 && time<10 ? '0'+time :time
}

// 获取当前月的时间
export const getMonthTime =()=>{
    let currentime = new Date()
    let year = currentime.getFullYear()
    let month = currentime.getMonth() + 1
    let day = currentime.getDate()
    let time = {
        end : correction(year) + '-' + correction(month) + '-' + correction(day),
        start : correction(year) + '-' + correction(month) + '-1'
    }
    return time
}

// 获取最近7天的时间 
export const getSevenDays =()=>{

    // let time = {
    //     one : getOneDay(-6),
    //     two : getOneDay(-5),
    //     three : getOneDay(-4),
    //     four : getOneDay(-3),
    //     five : getOneDay(-2),
    //     six : getOneDay(-1),
    //     seven : getOneDay(0),
    // }
    let time = {
        one : getOneDay(0),
        two : getOneDay(-1),
        three : getOneDay(-2),
        four : getOneDay(-3),
        five : getOneDay(-4),
        six : getOneDay(-5),
        seven : getOneDay(-6),
    }
    return time
}

// 测试获取最近7天的日期
const getOneDay = (day)=>{
    let today = new Date();
    let targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
    today.setTime(targetday_milliseconds); //注意，这行是关键代码
    let tYear = today.getFullYear();
    let tMonth = today.getMonth();
    let tDate = today.getDate();
    tMonth = correction(tMonth + 1);
    tDate = correction(tDate);
    return tYear+"-"+tMonth+"-"+tDate;
}